import { Media } from "@gogive/types";
import { apiRequest, axiosInstance } from "../client";
import { mediaRoutes } from "./media.route";

export interface UpdateMediaDTO {
  crops?: {
    x: number;
    y: number;
    width: number;
    height: number;
    originalWidth: number;
    originalHeight: number;
  };
  focalPoint?: {
    x: number;
    y: number;
  };
}

export interface CreateMediaDTO {
  accountId?: string;
  originalName: string;
  contentType: string;
  sizeBytes?: string;
  purpose?: "AVATAR" | "CONTENT";
  focalPoint?: {
    x: number;
    y: number;
  };
}

export interface MediaUploadUrlResponseDTO {
  media: Media;
  signedUrl: string;
}

export const createMediaRequest = (data: CreateMediaDTO) =>
  apiRequest<MediaUploadUrlResponseDTO>(mediaRoutes.create, {
    method: "POST",
    data,
  });

export const updateMediaRequest = async (id: number, data: UpdateMediaDTO) => {
  const response = await axiosInstance.patch<Media>(mediaRoutes.update(id), data);
  return response.data;
};

export const getMediaRequest = (id: number) =>
  apiRequest<Media>(mediaRoutes.get(id), {
    method: "GET",
  });

export const notifyMediaUploadedRequest = (mediaId: number) =>
  apiRequest<Media>(mediaRoutes.notifyUploaded(mediaId), {
    method: "POST",
  });

export type MediaListResponse = {
  rows: Media[];
  total: number;
  page: number;
  limit: number;
  pages: number;
};

export const listMediaRequest = (params?: {
  page?: number;
  limit?: number;
  accountId?: string;
}) =>
  apiRequest<MediaListResponse>(mediaRoutes.list, {
    method: "GET",
    params: {
      page: params?.page ?? 0,
      limit: params?.limit ?? 50,
      ...(params?.accountId ? { accountId: params.accountId } : {}),
    },
  });

export const deleteMediaRequest = (id: number) =>
  apiRequest<{ id: number }>(mediaRoutes.delete(id), {
    method: "DELETE",
  });

